import { useEffect } from 'react';
import Slider from 'react-slick';
import Grid from 'antd/lib/grid';
import classNames from 'classnames';

import CardGame from 'src/components/CardGame';
import { IGame } from 'src/interface';

import classes from './index.module.less';

interface Props {
	className?: string;
	items: IGame[];
	isLoading: boolean;
}

const RelatedGameList = ({ className = '', items, isLoading }: Props) => {
	const breakpoint = Grid.useBreakpoint();
	const { xs, sm } = breakpoint;

	let slidesToShow = 2;
	let centerMode = false;
	let arrows = true;
	if (xs && !sm) {
		slidesToShow = 1;
		centerMode = true;
		arrows = false;
	}

	const handleSliderArrowsPosition = () => {
		const slickPrev = document.querySelectorAll<HTMLElement>(`.${classes.slider} .slick-prev`)[0];
		const slickNext = document.querySelectorAll<HTMLElement>(`.${classes.slider} .slick-next`)[0];

		if (slickPrev) {
			const currentLeftPos = slickPrev?.getBoundingClientRect()?.left ?? 0;
			const currentLeftStyle = parseInt(window.getComputedStyle(slickPrev).left ?? '0');
			if (currentLeftPos < 0) {
				const newLeftStyle = currentLeftStyle - currentLeftPos;
				slickPrev.style.left = `${newLeftStyle}px`;
			} else {
				if (currentLeftStyle !== -85) {
					const diff = currentLeftStyle + 85;
					if (currentLeftPos - diff >= 0) {
						slickPrev.style.left = '-85px';
					} else {
						const newLeftStyle = currentLeftStyle - currentLeftPos;
						slickPrev.style.left = `${newLeftStyle}px`;
					}
				}
			}
		}

		if (slickNext) {
			const windowWidth = window.innerWidth - 10;
			const currentRightPos = slickNext?.getBoundingClientRect()?.right ?? 0;
			const currentRightStyle = parseInt(window.getComputedStyle(slickNext).right ?? '0');
			if (currentRightPos > windowWidth) {
				const newRightStyle = currentRightStyle + (currentRightPos - windowWidth);
				slickNext.style.right = `${newRightStyle}px`;
			} else {
				if (currentRightStyle !== -85) {
					const diff = currentRightStyle + 85;
					if (currentRightPos + diff < windowWidth) {
						slickNext.style.right = '-85px';
					} else {
						const newRightStyle = currentRightStyle - (windowWidth - currentRightPos);
						slickNext.style.right = `${newRightStyle}px`;
					}
				}
			}
		}
	};

	useEffect(() => {
		window.addEventListener('resize', handleSliderArrowsPosition);

		return () => {
			window.removeEventListener('resize', handleSliderArrowsPosition);
		};
	}, []);

	useEffect(() => {
		handleSliderArrowsPosition();
	}, [JSON.stringify(items)]);

	return (
		<div className={classNames(classes['slider-container'], className)}>
			<Slider
				key={JSON.stringify(items ?? {})}
				className={classes.slider}
				infinite
				adaptiveHeight={true}
				centerMode={centerMode}
				centerPadding="15%"
				slidesToShow={slidesToShow}
				slidesToScroll={centerMode ? 1 : slidesToShow}
				arrows={arrows}
			>
				{(isLoading ? new Array(slidesToShow).fill({ id: 'loading' }) : items)?.map(
					(item: IGame) => (
						<div key={item?.id} className={classes['slide-container']}>
							<CardGame item={item} isLoading={isLoading} />
						</div>
					),
				)}
			</Slider>
		</div>
	);
};

export default RelatedGameList;
